import { useQuery } from "@tanstack/react-query";
import { appRolesApi } from "../api/app-roles";

const appRoleKeys = {
  all: ["app-roles"] as const,
  list: () => [...appRoleKeys.all, "list"] as const,
  detail: (name: string) => [...appRoleKeys.all, name] as const,
};

export function useAppRoles() {
  return useQuery({
    queryKey: appRoleKeys.list(),
    queryFn: () => appRolesApi.list(),
    refetchInterval: 30_000,
  });
}

export function useAppRole(name: string) {
  return useQuery({
    queryKey: appRoleKeys.detail(name),
    queryFn: () => appRolesApi.get(name),
    enabled: !!name,
  });
}
